export const createStyles = (theme: any) => ({
  conversationContainerStyles: {
    padding: { xs: '0.8rem 0.5rem', sm: '1.2rem 1.5rem' },
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '0.8rem', sm: '1rem' },
  },
  headerStyle: {
    margin: {
      xs: '0 0 0 -0.5rem',
      sm: '0 0 0 -0.5rem',
    },
  },
});
